import { featureEnabled, isValidUrl } from 'utils';

angular.module('bb.assets').component('bbAssetsList', {
  bindings: {},
  controller: AssetsListController,
  controllerAs: 'vm',
  template: require('./assets_list.html'),
});

AssetsListController.$inject = [
  'ModalService',
  'AssetsService',
  '$location',
  '$routeParams',
  '$rootScope',
  '$sce',
];

function AssetsListController(
  ModalService,
  AssetsService,
  $location,
  $routeParams,
  $rootScope,
  $sce,
) {
  const vm = this;
  vm.auth = $rootScope.auth;

  vm.page = 1;
  vm.pageSize = 5;

  vm.folderPageSize = 6;

  vm.adminFolders = [];

  vm.nonAdminFolders = [];

  const orgFileName = `${vm.auth.org.name} Files`;

  const sortFiles = (a, b) => {
    // Move folders to top
    const isFolderA = a.filetype === 'folder';
    const isFolderB = b.filetype === 'folder';
    if (isFolderA !== isFolderB) return isFolderB - isFolderA;

    // Sort files by name
    return a.name.localeCompare(b.name);
  };

  vm.displayMode = 'list';
  vm.setDisplayMode = mode => {
    vm.displayMode = mode;
  };

  vm.$onInit = () => {
    vm.loadingFolders = true;
    vm.folderIdMap = {};
    vm.adminFoldersPage = 1;
    vm.nonAdminFoldersPage = 1;
    vm.adminPageNumbers = [];
    vm.nonAdminPageNumbers = [];

    // Getting initial folders
    vm.fetchFolders(1, 'nonAdmin', vm.folderPageSize);

    if (vm.auth.isAdmin) {
      vm.fetchFolders(1, 'admin', vm.folderPageSize);
    }

    if (vm.selectedFolder) {
      vm.selectFolder(vm.selectedFolder.id, 'build');
    } else vm.selectFolder($routeParams.folderId, 'build');
    vm.loadingFolders = false;
  };

  vm.fetchFiles = () => {
    vm.loadingFiles = true;
    let folderId;

    if (vm.selectedFolder) folderId = vm.selectedFolder.id;

    AssetsService.getFiles(folderId, vm.page, vm.pageSize)
      .then(({ assets: files, totalAssets: totalFiles }) => {
        vm.totalFiles = totalFiles;
        vm.files = files;
        vm.pageNumbers = [];
        vm.folders = [];
      })
      .then(async () => {
        // Getting the folders for each file / folder selected
        const { assets: nonAdminFolders, totalAssets: totalNonAdminFolders } =
          await AssetsService.getFolders(vm.page, vm.pageSize, false, folderId);
        vm.folders = [...nonAdminFolders];
        vm.totalFiles +=
          totalNonAdminFolders > vm.totalFiles && totalNonAdminFolders;
        if (vm.auth.isAdmin) {
          const { assets: adminFolders, totalAssets: totalAdminFolders } =
            await AssetsService.getFolders(
              vm.page,
              vm.pageSize,
              vm.auth.isAdmin,
              folderId,
            );
          vm.folders = [...vm.folders, ...adminFolders];
          vm.totalFiles +=
            totalAdminFolders > vm.totalFiles && totalAdminFolders;
        }

        vm.folders = vm.folders.map(folder => {
          const newFolder = { ...folder };
          newFolder.filetype = 'folder';
          newFolder.url = `#/assets/?folderId=${folder.id}`;
          return newFolder;
        });

        vm.folders.forEach(folder => {
          vm.folderIdMap[folder.id] = folder;
        });

        vm.files = [...vm.folders, ...vm.files].sort(sortFiles);
        vm.files = vm.files.map(file => {
          const newFile = file;
          newFile.cssClass = AssetsService.determineCssClass(file.filetype);
          return newFile;
        });
      })
      .then(() => {
        vm.pageNumbers = [];
        vm.updatePageNumbers(
          vm.pageNumbers,
          vm.page,
          vm.totalFiles,
          vm.pageSize,
        );
        vm.loadingFiles = false;
      });
  };
  vm.getLastPage = folderType => {
    if (folderType === 'nonAdmin') {
      return Math.ceil(vm.totalNonAdminFolders / vm.folderPageSize);
    }

    if (folderType === 'admin') {
      return Math.ceil(vm.totalAdminFolders / vm.folderPageSize);
    }

    return Math.ceil(vm.totalFiles / vm.pageSize);
  };

  vm.nonAdminPageHandler = page => {
    vm.getPage(page, 'nonAdmin');
  };

  vm.adminPageHandler = page => {
    vm.getPage(page, 'admin');
  };

  vm.filePageHandler = page => {
    vm.getPage(page);
  };

  vm.getPage = async (number, fileType) => {
    if (number > 0 && number <= vm.getLastPage(fileType)) {
      if (fileType) {
        await vm.fetchFolders(number, fileType, vm.folderPageSize);
      } else {
        vm.page = number;
        vm.fetchFiles();
      }
    }
  };

  vm.showPaginationEllipsis = (
    pageNumbers,
    totalFolders,
    pageSize,
    type = '',
  ) => {
    if (pageNumbers) {
      return (
        pageNumbers[pageNumbers.length - 1] < totalFolders / pageSize &&
        pageNumbers[pageNumbers.length - 1] + 1 !== vm.getLastPage(type)
      );
    }
  };

  vm.fetchFolders = async (number, fileType, pageSize) => {
    vm.loadingFolders = true;
    if (fileType === 'nonAdmin') {
      vm.nonAdminFoldersPage = number;
      AssetsService.getFolders(vm.nonAdminFoldersPage, pageSize, false)
        .then(
          ({ assets: nonAdminFolders, totalAssets: totalNonAdminFolders }) => {
            vm.nonAdminFolders = nonAdminFolders.sort(sortFiles);
            nonAdminFolders.forEach(folder => {
              vm.folderIdMap[folder.id] = folder;
            });
            vm.totalNonAdminFolders = totalNonAdminFolders;
            vm.loadingFolders = false;
          },
        )
        .then(() => {
          vm.nonAdminPageNumbers = [];
          vm.updatePageNumbers(
            vm.nonAdminPageNumbers,
            vm.nonAdminFoldersPage,
            vm.totalNonAdminFolders,
            pageSize,
          );
        });
    } else if (fileType === 'admin') {
      if (vm.auth.isAdmin) {
        vm.adminFoldersPage = number;
        AssetsService.getFolders(vm.adminFoldersPage, pageSize, vm.auth.isAdmin)
          .then(({ assets: adminFolders, totalAssets: totalFolders }) => {
            vm.adminFolders = adminFolders.sort(sortFiles);
            vm.totalAdminFolders = totalFolders;
            adminFolders.forEach(folder => {
              vm.folderIdMap[folder.id] = folder;
            });
            vm.loadingFolders = false;
          })
          .then(() => {
            vm.adminPageNumbers = [];
            vm.updatePageNumbers(
              vm.adminPageNumbers,
              vm.adminFoldersPage,
              vm.totalAdminFolders,
              pageSize,
            );
          });
      }
    }
  };

  vm.updatePageNumbers = (pageNumbers, page, totalAssets, pageSize) => {
    // Adding Pagination for admin folders
    const currentPage = parseInt(page, 10);
    for (
      let pageNumber = currentPage - 2;
      pageNumber <= currentPage + 2 &&
      pageNumber <= Math.ceil(totalAssets / pageSize);
      pageNumber++
    ) {
      if (pageNumber > 0) {
        pageNumbers.push(pageNumber);
      }
    }
  };

  vm.selectFolder = async (folderId, breadcrumbAction) => {
    // Resetting the page number to 1
    vm.page = 1;

    let folder;
    if (vm.folderIdMap[folderId]) {
      folder = vm.folderIdMap[folderId];
    } else {
      folder = await AssetsService.getFolderById(folderId);
      vm.folderIdMap[folder.id] = folder;
    }

    vm.selectedFolder = folder;
    if (!vm.selectedFolder) folderId = undefined;

    if (breadcrumbAction === 'add') {
      vm.breadcrumbs.push({
        id: vm.selectedFolder.id,
        name: vm.selectedFolder.name,
      });
    } else if (breadcrumbAction === 'remove') vm.breadcrumbs.pop();
    else if (breadcrumbAction === 'build') {
      let parentFolderId;

      if (folderId) {
        vm.breadcrumbs = [
          {
            id: vm.selectedFolder.id,
            name: vm.selectedFolder.name,
          },
        ];
        parentFolderId = vm.selectedFolder.parent;
      } else {
        vm.breadcrumbs = [];
      }

      vm.getParentBreadCrumb(parentFolderId).then(() => {
        vm.breadcrumbs.push({
          id: null,
          name: orgFileName,
        });
        vm.breadcrumbs.reverse();
      });
    }

    $location.search({
      folderId,
    });
    vm.fetchFiles();
  };

  // Builds the breadcrumb for the selected folder
  vm.getParentBreadCrumb = async parentFolderId => {
    if (parentFolderId) {
      let parentFolder;
      if (vm.folderIdMap[parentFolderId]) {
        parentFolder = vm.folderIdMap[parentFolderId];
      } else {
        parentFolder = await AssetsService.getFolderById(parentFolderId);
        vm.folderIdMap[parentFolder.id] = parentFolder;
      }
      vm.breadcrumbs.push({
        id: parentFolder.id,
        name: parentFolder.name,
      });
      const parentId = parentFolder.parent;
      if (parentId) return vm.getParentBreadCrumb(parentId);
    }
  };

  vm.updateFileName = (fileId, updatedName) => {
    const foundFile = vm.files.find(file => file.id === fileId);
    foundFile.name = updatedName;
  };

  vm.openManageFolder = (event, folder, isRootFolder) => {
    if (event) event.stopPropagation();
    let parentId;
    if (vm.selectedFolder && !isRootFolder) {
      parentId = vm.selectedFolder.id;
    }
    ModalService.openFolderModal(folder, parentId).then(updated => {
      if (updated) {
        vm.$onInit();
      }
    });
  };

  vm.openVideoPlayer = (event, file) => {
    const cleanedEmbedUrl = $sce.trustAsResourceUrl(file.embedUrl);

    if (event) event.preventDefault();
    ModalService.openPlayerModal(
      {
        ...file,
        embedUrl: cleanedEmbedUrl,
      },
      vm.updateFileName,
    );
  };

  vm.openAddVideo = event => {
    if (event) event.stopPropagation();
    let parentId;
    if (vm.selectedFolder) {
      parentId = vm.selectedFolder.id;
    }
    ModalService.openAddVideoModal(parentId).then(updated => {
      if (updated) {
        vm.$onInit();
      }
    });
  };

  vm.openUploadFile = () => {
    const processResult = result => {
      if (result.filesUploaded && result.filesUploaded.length > 0) {
        vm.loadingFiles = true;

        let parentId;
        if (vm.selectedFolder) {
          parentId = vm.selectedFolder.id;
        }

        AssetsService.assetFileUpload(result.filesUploaded, parentId).then(
          () => {
            vm.fetchFiles();
          },
        );
      }
    };

    const disallowedFileTypes = [
      'html',
      'exe',
      'bat',
      'sh',
      'py',
      'js',
      'jar',
      'dll',
      'php',
      'pl',
      'rb',
      'cgi',
      'ps1',
      'wsf',
      'vbs',
      'cmd',
      'iso',
      'zip',
    ];

    const opts = {
      maxFiles: 10,
      maxSize: 100 * 1024 * 1024, // 100 MB
      onFileSelected: file => {
        const fileType = file.mimetype.split('/')[1];
        if (disallowedFileTypes.includes(fileType)) {
          throw new Error(`The file type ${fileType} is not allowed.`);
        }
        if (file.source === 'url' && !isValidUrl(file.originalPath))
          throw new Error('Invalid URL format. Please try again.');
      },
      onUploadDone: result => processResult(result),
    };

    const picker = fileStackClient.picker(opts);
    picker.open();
  };

  vm.deleteFolder = (selectedFolder, cb) => {
    swal(
      {
        title: 'Delete Folder',
        text: 'Are you sure you want to permanently delete this folder and all of its contents?',
        html: true,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        confirmButtonText: 'Delete',
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      () => {
        cb();
        AssetsService.deleteFolder(selectedFolder.id).then(() => {
          vm.$onInit();
        });
      },
    );
  };

  vm.deleteFile = file => {
    swal(
      {
        title: 'Delete File',
        text: 'Are you sure you want to permanently delete this file?',
        html: true,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#62cb31',
        confirmButtonText: 'Delete',
        closeButtonText: 'Cancel',
        closeOnConfirm: true,
      },
      () => {
        AssetsService.deleteFile(file.id).then(() => {
          vm.selectFolder(file.folder, 'build');
        });
      },
    );
  };

  vm.hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
}

export {};
